import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import backgroundImage from "../assets/background.jpg"; // Placeholder for background image

const Career = () => {
  return (
    <div
      className="min-h-screen text-white"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
        backgroundRepeat: "no-repeat",
        backgroundColor: "#1e3a8a",
        background: `linear-gradient(135deg, rgba(30, 58, 138, 0.8), rgba(6, 182, 212, 0.8)), url(${backgroundImage})`,
      }}
    >
      {/* Hero Banner */}
      <div className="bg-black/30 backdrop-blur-sm text-white py-16 px-4 md:px-8">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-extrabold mb-4 animate-fade-in">
            Careers at Virtueista IT
            <span className="block text-yellow-500 mt-2">
              Join Us in Shaping Nepal’s Tech Future
            </span>
          </h1>
          <p className="text-lg md:text-xl max-w-2xl mx-auto mb-6">
            Be part of a dynamic team in Biratnagar, Nepal, empowering students
            and building innovative software solutions.
          </p>
          <a
            href="mailto:virtueistait@gmail.com?subject=Job Application"
            className="bg-yellow-500 text-blue-900 py-3 px-6 rounded-md font-semibold hover:bg-yellow-600 transform hover:scale-105 transition-all duration-300 shadow-md"
          >
            Apply Now
          </a>
        </div>
      </div>

      {/* Introduction */}
      <div className="max-w-7xl mx-auto px-4 py-12 md:py-16 bg-gray-50 rounded-xl">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800">
            Empowering Nepal’s Future IT Professionals
          </h2>
          <p className="text-gray-600 mt-4 max-w-3xl mx-auto">
            Virtueista IT is an IT training institute and software company based
            in Biratnagar, Nepal. We specialize in delivering career-focused IT
            professional courses while developing real-world software solutions
            for clients. Our mission is to bridge the gap between learning and
            industry, and we’re looking for passionate individuals to join our
            team—whether you’re an experienced developer, a dedicated trainer,
            or eager to grow in the tech education space.
          </p>
        </div>

        {/* Career Opportunities */}
        <div className="mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 text-center mb-8">
            Career Opportunities
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* Training & Education Roles */}
            <div className="bg-white/10 backdrop-blur-sm p-6 rounded-lg shadow-lg transform hover:scale-105 transition-transform duration-300">
              <h3 className="text-xl font-semibold text-gray-800 mb-4 flex items-center">
                <svg
                  className="w-6 h-6 text-blue-600 mr-2"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z" />
                </svg>
                Training & Education Roles
              </h3>
              <ul className="text-gray-600 space-y-2">
                {[
                  "Web Development Instructors (HTML, CSS, JavaScript, React)",
                  "Python Programming & Data Science Trainers",
                  "Digital Marketing & Content Creation Coaches",
                  "Canva, Video Editing & Social Media Mentors",
                ].map((role, index) => (
                  <li key={index} className="flex items-start">
                    <svg
                      className="w-5 h-5 text-yellow-500 mr-2 mt-1"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                    </svg>
                    {role}
                  </li>
                ))}
              </ul>
            </div>
            {/* Software & Project Roles */}
            <div className="bg-white/10 backdrop-blur-sm p-6 rounded-lg shadow-lg transform hover:scale-105 transition-transform duration-300">
              <h3 className="text-xl font-semibold text-gray-800 mb-4 flex items-center">
                <svg
                  className="w-6 h-6 text-blue-600 mr-2"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4zm2.5 2.1h-15V5h15v14.1zm0-16.1h-15c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h15c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" />
                </svg>
                Software & Project Roles
              </h3>
              <ul className="text-gray-600 space-y-2">
                {[
                  "Front-End & Back-End Developers",
                  "Mobile App Developers",
                  "UI/UX Designers",
                  "Project Managers & Technical Support Staff",
                ].map((role, index) => (
                  <li key={index} className="flex items-start">
                    <svg
                      className="w-5 h-5 text-yellow-500 mr-2 mt-1"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                    </svg>
                    {role}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Why Work With Us */}
        <div className="mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 text-center mb-8">
            Why Work With Us?
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            {[
              {
                title: "Industry Exposure",
                description:
                  "Be part of a leading IT institute with real-world project experience.",
                icon: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z",
              },
              {
                title: "Impactful Teaching",
                description:
                  "Help students from SEE to college level build career-ready tech skills.",
                icon: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z",
              },
              {
                title: "Dual Role Opportunity",
                description:
                  "Work on live software projects while teaching aspiring tech professionals.",
                icon: "M9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4zm2.5 2.1h-15V5h15v14.1zm0-16.1h-15c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h15c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z",
              },
              {
                title: "Flexible Hours",
                description:
                  "Enjoy flexible schedules for both physical and online classes.",
                icon: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z",
              },
              {
                title: "Supportive Environment",
                description:
                  "Thrive in a growth-oriented, friendly, and collaborative workplace.",
                icon: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z",
              },
            ].map((benefit, index) => (
              <div
                key={index}
                className="bg-white/10 backdrop-blur-sm p-6 rounded-lg shadow-lg transform hover:scale-105 transition-transform duration-300"
              >
                <svg
                  className="w-8 h-8 text-blue-600 mb-3"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d={benefit.icon} />
                </svg>
                <h3 className="text-lg font-semibold text-gray-800 mb-2">
                  {benefit.title}
                </h3>
                <p className="text-gray-600">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Call to Action */}
        <div className="text-center bg-black/30 backdrop-blur-sm text-white py-12 px-4 rounded-xl">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Ready to Join Our Team?
          </h2>
          <p className="text-lg max-w-2xl mx-auto mb-6">
            Send your CV to{" "}
            <a
              href="mailto:virtueistait@gmail.com?subject=Job Application"
              className="underline hover:text-yellow-500"
            >
              Virtueistait@gmail.com
            </a>{" "}
            or explore our current openings below.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <a
              href="mailto:Virtueistait@gmail.com?subject=Job Application"
              className="bg-yellow-500 text-blue-900 py-3 px-6 rounded-md font-semibold hover:bg-yellow-600 transition-all duration-300"
            >
              Apply Now
            </a>
            <a
              href="#"
              className="bg-white text-blue-800 py-3 px-6 rounded-md font-semibold hover:bg-gray-100 transition-all duration-300"
            >
              Explore Openings
            </a>
          </div>
        </div>
      </div>

      {/* Floating WhatsApp Button */}
      <a
        href="https://wa.me/9779849489441"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed right-4 top-1/2 transform -translate-y-1/2 bg-green-500 text-white p-4 rounded-full shadow-lg hover:bg-green-600 hover:scale-110 transition-all duration-300 z-50"
        aria-label="Chat with us on WhatsApp"
      >
        <FaWhatsapp className="w-6 h-6 animate-spin-slow" />
      </a>

      {/* Inline CSS for Animations */}
      <style>
        {`
          @keyframes fade-in {
            0% { opacity: 0; transform: translateY(20px); }
            100% { opacity: 1; transform: translateY(0); }
          }
          .animate-fade-in {
            animation: fade-in 1s ease-out;
          }
          .hover\\:scale-105:hover {
            transform: scale(1.05);
          }
          @keyframes spin-slow {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          .animate-spin-slow {
            animation: spin-slow 4s linear infinite;
          }
          @media (max-width: 640px) {
            div[style*="background-attachment: fixed"] {
              background-attachment: scroll;
            }
          }
        `}
      </style>
    </div>
  );
};

export default Career;
